export function getErrorHandler(Vue, apm) {
	/**
     * If the user already installed a global error handler
     * we should call them after capturing it internally
     */
	const previousErrorHandler = Vue.config.errorHandler;

	return (error, vm, info) => {
		if (vm && vm.$options) {
			const options = vm.$options;
			const component = vm.$root === vm ? "Root" : options.name || options._componentTag || "Anonymous";

			error.component = component;
			error.file = options.__file || "";
		}

		/**
       * Lifecycle hook the error was thrown if available
       */
		if (info) {
			error.lifecycleHook = info;
		}

		apm.captureError(error);

		if (typeof previousErrorHandler === "function") {
			previousErrorHandler.call(this, error, vm, info);
		}
		/**
       * Logs the error to browser console similar
       * to original Vue logError
       */
		// eslint-disable-next-line no-console
		console.error(error);
	};
}